import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import markdown from '../content/legal/candidate-privacy-notice.md?raw';
import CandidateFooter from '../components/CandidateFooter';
import '../styles/legalDoc.css';

/**
 * Public, no-auth Candidate Privacy Notice for /screen/privacy.
 * Does NOT use SiteHeader/Footer because the candidate flow has its
 * own minimal chrome (matches ScreeningScreen).
 */
export default function CandidatePrivacyScreen() {
  const html = useMemo(() => {
    const rendered = marked.parse(markdown || '', { gfm: true, breaks: false });
    return DOMPurify.sanitize(rendered);
  }, []);

  return (
    <main className="bg-[#F0F0F0] min-h-screen">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
        <nav className="text-sm text-gray-500 mb-6">
          <Link to="/" className="hover:text-gray-700">Jobskills</Link>
          <span className="mx-2">/</span>
          <span className="text-gray-700">Candidate Privacy Notice</span>
        </nav>
        <article
          className="legal-doc bg-white rounded-2xl shadow-sm p-6 sm:p-10"
          dangerouslySetInnerHTML={{ __html: html }}
        />
        <CandidateFooter />
      </div>
    </main>
  );
}
